import i18next from 'i18next';

import { CustomerListMatchingAttribute } from '~/types/api.graphql';

/** The order types are offered in: the most used first, so Email and Phone lead and names come before the address. */
export const MATCHING_ATTRIBUTE_ORDER: CustomerListMatchingAttribute[] = [
  CustomerListMatchingAttribute.Email,
  CustomerListMatchingAttribute.Phone,
  CustomerListMatchingAttribute.EmailMd5,
  CustomerListMatchingAttribute.Maid,
  CustomerListMatchingAttribute.FirstName,
  CustomerListMatchingAttribute.LastName,
  CustomerListMatchingAttribute.Address,
  CustomerListMatchingAttribute.State,
  CustomerListMatchingAttribute.Zip,
  CustomerListMatchingAttribute.Zip4,
];

/** A matching attribute as people read it, the same when picked and once the audience exists, e.g. "MAID". */
export const getMatchingAttributeLabel = (attribute: CustomerListMatchingAttribute) =>
  i18next.t(`audience.people.matchingAttributes.${attribute}`);
